$(function(){
	if ($('.birthday-datetime').length > 0){
		$.datetimepicker.setLocale('ja');
		$(".birthday-datetime").datetimepicker({
			timepicker:false,
			format:'Y/m/d',
			defaultDate:'2020-01-01',
		});
	}
	if($('.main.password-change').length) {
		$(function() {
			$('.js-password-change-submit').prop("disabled", true).addClass('disabled-btn');
			// パスワード確認を表示
			function equal() {
				$('.js-pass-confirmation').fadeIn();
				$('.password').closest('.form-group').addClass('js-pass-match');
				$('.password_confirmation').closest('.form-group').addClass('js-pass-match');
				$('.js-password-change-submit').prop("disabled", false).removeClass('disabled-btn');
			}
			// パスワード確認を非表示
			function unequal() {
				$('.js-pass-confirmation').fadeOut();
				$('.js-pass-confirmation input').val('');
				$('.password').closest('.form-group').removeClass('js-pass-match');
				$('.password_confirmation').closest('.form-group').removeClass('js-pass-match');
				$('.js-password-confirmation-btn').addClass('secret').prev('.js-password-confirmation-input').attr('type', 'password');
				$('.js-password-confirmation-btn').html('<img src="/img/common/icon/open-eye.svg" alt=""><span>パスワードを表示</span>');
				$('.js-password-change-submit').prop("disabled", true).addClass('disabled-btn');
			}

			// 新しいパスワード について
			function password() {
				if($('.password').val() != '' && $('.password_confirmation').val() != '') {
					if($('.password').val() == $('.password_confirmation').val() && $('.password').val().length >=8) {
						$('.js-pass-confirmation input').val($('.password').val());
						equal();
					}else{
						unequal();
					}
				}else if(($('.password').val() != '' && $('.password_confirmation').val() == '') || ($('.password').val() == '' && $('.password_confirmation').val() != '')) {
					// どっちかが空だったらパスワード確認を非表示
					unequal();
				}
			}
			// 新しいパスワードを再度ご入力ください について
			function passwordConfirmation() {
				if($('.password').val() != '' && $('.password_confirmation').val() != '' ) {
					if($('.password').val() == $('.password_confirmation').val() && $('.password').val().length >=8) {
						$('.js-pass-confirmation input').val($('.password_confirmation').val());
						equal();
					}else{
						unequal();
					}
				}else if(($('.password').val() != '' && $('.password_confirmation').val() == '') || ($('.password').val() == '' && $('.password_confirmation').val() != '')) {
					// どっちかが空だったらパスワード確認を非表示
					unequal();
				}
			}
			// 新しいパスワード
					// 入力したら
					$(document).on('keyup', '.password', function(e) {
						password();
					});
					// フォーカスが外れたら
					$('input.password').blur(password);

			// 新しいパスワードを再度ご入力ください
					// 入力したら
					$(document).on('keyup', '.password_confirmation', function(e) {
						passwordConfirmation();
					});
					// フォーカスが外れたら
					$('input.password_confirmation').blur(passwordConfirmation);
		});
		// パスワードを表示
		$(document).on(oEventNames.end, '.js-password-confirmation-btn', function (event) {
			if (!bIsScrolling) {
				event.preventDefault();
				if($('.js-password-confirmation-btn').hasClass('secret')) {
					$(this).removeClass('secret').prev('.js-password-confirmation-input').attr('type', 'text');
					$(this).html('<img src="/img/common/icon/close-eye.svg" alt=""><span>パスワードを非表示</span>');
				}else{
					$(this).addClass('secret').prev('.js-password-confirmation-input').attr('type', 'password');
					$(this).html('<img src="/img/common/icon/open-eye.svg" alt=""><span>パスワードを表示</span>');
				};
			}
		});
	}
});
